import { useEffect } from 'react'

const resetScroll = () => {
  const scrollPosition = document.documentElement.scrollTop || window.pageYOffset
  if (scrollPosition > 499) {
    window.scrollTo(0, 0)
    window.scrollTo(0, 500)
  }
}

const useScrollReset = () => {
  useEffect(() => {
    resetScroll()
  }, [])
}

export { useScrollReset, resetScroll }